import { SELL_API as axios } from '@services/axiosInstance';
import type { FrontendConfigDTO } from '@t/api.types';

// SELL_API's baseURL ends in /cpq/v1, but /frontend/config is its sibling under
// the /sellbackend root — strip the /cpq/v1 segment for this one call.
export const toSellRootBaseUrl = (base: string): string => base.replace(/\/cpq\/v1\/?$/, '');

const sellRootBaseUrl = toSellRootBaseUrl(import.meta.env.VITE_SELL_BASE_URL ?? '');

export const getFrontendConfig = async (): Promise<FrontendConfigDTO> => {
  const { data } = await axios.get<FrontendConfigDTO>('/frontend/config', { baseURL: sellRootBaseUrl });
  return data;
};
